import imageUrlBuilder from '@sanity/image-url';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { sanityClient } from '../client';
import { Circles, Rings } from 'react-loader-spinner';

function Projects() {
  const [projectsInfo, setProjectsInfo] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(`*[_type=="project"]`)
      .then((data) => setProjectsInfo(data))
      .catch(console.error);
  }, []);
  const builder = imageUrlBuilder(sanityClient);
  function urlFor(source) {
    return builder.image(source);
  }
  if (!projectsInfo)
    return (
      <div className="flex  items-center justify-center ">
        <Circles height={30} width={30} color="[#5bccf6]" />
      </div>
    );
  return (
    <motion.div
      initial={{ opacity: 0 }}
      transition={{ duration: 1.2 }}
      whileInView={{ opacity: 1 }}
      className="h-fit  relative flex overflow-hidden flex-col text-center md:text-left md:flex-row max-w-full justify-evenly mx-auto items-center z-0"
    >
      <h3 className="absolute text-center top-0 uppercase tracking-[20px] text-gray-500">
        Projects
      </h3>
      <div className="relative mt-16 w-full flex overflow-x-scroll overflow-y-hidden snap-x snap-mandatory z-20 scrollbar scrollbar-track-[#5bccf6]/20 scrollbar-thin  scrollbar-thumb-[#5bccf6]">
        {projectsInfo.map((project, index) => {
          const projecturl = urlFor(project?.image?.asset?._ref).url();
          return (
            <div
              key={index}
              className="w-screen flex-shrink-0 snap-center flex flex-col space-y-2 items-center p-5 md:p-0 h-screen"
            >
              <motion.img
                initial={{ y: -100, opacity: 0 }}
                transition={{ duration: 1.2 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                alt={project?.title}
                src={projecturl}
                className="h-[300px] md:w-[600px]   md:w-[500px] rounded-md object-cover"
              />
              <h4 className="tracking-[5px]">
                <span className="underline decoration-[#5bccf6]  font-semibold text-center">
                  Project {index + 1}
                </span>{' '}
                .{project?.title}
              </h4>
              <p className="text-[10px] md:w-[90%] mb-4 text-left md:text-lg text-black">
                {project?.summary}
              </p>
              <div>
                <h4 className="text-center tracking-[5px]">
                  Technologies Used
                </h4>
                <div className="flex flex-wrap w-[300px] md:w-[500px] gap-4 mx-auto justify-around">
                  {project?.technoligies.map((tech, index) => (
                    <p className="skillTech" key={index}>
                      {tech}
                    </p>
                  ))}
                </div>
              </div>
              <a
                href={project?.linkToBuild}
                target="_blank"
                className="pb-10 group hover:text-[#5bccf6] gap-4 items-center text-sm flex transition-all duration-300"
              >
                <p className="tracking-[5px] font-bold">Link To the build </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                  />
                </svg>
              </a>
            </div>
          );
        })}
      </div>
      <div className="w-full absolute top-[30%] bg-[#7c5809]  left-0 h-[300px] md:h-[400px] w-full -skew-y-12"></div>
    </motion.div>
  );
}

export default Projects;
